// Comparison on ?live=1: Ben's own scatter (`data/comparison.ts` computeComparisonPoints)
// plotted from the shared group (`live/group-players.ts`) — her league's file for the season picked.
//
// As Ranking / Filter: with a Position chip on, the dots are minutes AT each position (Ben's
// Position rule, rules.md), so a player who played two of the chip's positions plots twice; each
// dot then says which position it is ("at Full Back") where the snapshot shows the league.

import type { RangeFilterConfig, ActiveFilters } from "../engines/stats-filter-kit.js";
import { COMPARISON_RANGE_FILTERS } from "../data/comparison.js";
import { humanizePositionTemplate } from "../modules/bio-view.js";
import { LIVE_RANGE_FILTERS } from "./stats-files.js";
import type { GroupPlayer } from "./group-players.js";

/** The live chips, in Ben's add-menu order: the ones the files have data for (as Filter's).
 *  League waits for Q-010 (the group already IS her league); Height, Weight and Preferred Foot
 *  stay hidden on real data (Q-013). Minutes: rules.md's chip for every module. */
export const LIVE_COMPARISON_CHIPS = ["league", "position", "club", "nationality", "foot", "age", "height", "weight", "minutes"] as const;

/** Ben's absolute ranges + the Minutes chip. Height / Weight stay in so a chip carried over from a
 *  saved dashboard still reads right (and honestly matches nobody: the files have no heights). */
export const LIVE_COMPARISON_RANGE_FILTERS: RangeFilterConfig = {
  ...COMPARISON_RANGE_FILTERS,
  minutes: LIVE_RANGE_FILTERS.minutes!,
};

/** The fixed columns every file row has (`groupRowsOf` adds them itself), so not asked for by name. */
const FIXED = new Set(["minutes", "nineties_played"]);

/** The metric keys to read from the file: only the ones plotted (X, Y, size, colour), so one
 *  renamed engine key can't break every axis (a key the file lacks throws in `groupPlayers`). */
export function comparisonMetricKeys(keys: readonly (string | null)[]): string[] {
  return [...new Set(keys.filter((k): k is string => k !== null && !FIXED.has(k)))];
}

/** Ben's default chip is `League: FAWSL`. Live, the group is already her league (Q-010), so the
 *  chip is left out — also from a dashboard saved on the snapshot site, which would otherwise
 *  plot nobody for a man (or another league). Edits `active` in place (the chip bar holds it). */
export function dropLeagueChip(active: ActiveFilters): ActiveFilters {
  delete active.league;
  return active;
}

/** Position rows (Position chip on): each dot says which position it is, as Filter's rows do. */
export function labelPositionRows(players: Record<string, GroupPlayer>): Record<string, GroupPlayer> {
  const out: Record<string, GroupPlayer> = {};
  for (const [key, p] of Object.entries(players)) {
    out[key] = { ...p, competition: `at ${humanizePositionTemplate(p.positionTemplate ?? "")}` };
  }
  return out;
}
